export class ReportFAQReqRes {
  public id: number;
  public question: string;
  public answer: string;
  public isEdited = false;
}
